"use client";

import type { PosSettings } from "@/actions/ssr/getOnlineOrderSettingsSSR";
import { useAppDispatch } from "@/store/hooks";
import { setOnlineOrderSettings } from "@/store/slices/onlineOrderSettingsSlice";
import { useEffect } from "react";

interface OnlineOrderSettingsInitializerProps {
  settings: PosSettings | null;
}

export const OnlineOrderSettingsInitializer: React.FC<
  OnlineOrderSettingsInitializerProps
> = ({ settings }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (settings) {
      dispatch(setOnlineOrderSettings(settings));
    }
  }, [dispatch, settings]);

  return null;
};
